export enum places_status {
  INVALID_REQUEST = "This request was invalid",
  OK = "The response contains a valid result",
  OVER_QUERY_LIMIT = "The webpage has gone over its request quota",
  NOT_FOUND = "The referenced location was not found in the Places database",
  REQUEST_DENIED = "The webpage is not allowed to use the PlacesService",
  UNKNOWN_ERROR = "The PlacesService request could not be processed due to a server error. The request may succeed if you try again",
  ZERO_RESULTS = "No result was found for this request",
}

export enum scores_types {
  ClimateRisk = "ClimateRisk",
  DroughtRisk = "DroughtRisk",
  FireRisk = "FireRisk",
  FloodRisk = "FloodRisk",
  StormRisk = "StormRisk",
  TempRisk = "TempRisk",
}

export enum score_formatted_labels {
  ClimateRisk = "Climate",
  DroughtRisk = "Drought",
  FireRisk = "Fire",
  FloodRisk = "Flood",
  StormRisk = "Storm",
  TempRisk = "Heat",
}

export type Score = {
  score: number;
  type: scores_types;
  severity: SeverityLabels;
};

export enum SeverityLabels {
  relativelyLow = "Relatively Low",
  significant = "Significant",
  high = "High",
  veryHigh = "Very High",
  extreme = "Extreme",
  more = "None",
}

export interface SeverityRanges {
  relativelyLow: RelativelyLow;
  significant: Significant;
  high: HighRange;
  veryHigh: VeryHighRange;
  extreme: ExtremeRange;
  more: MoreRange;
}

export enum RelativelyLow {
  min = 0,
  max = 19,
}

export enum Significant {
  min = 20,
  max = 39,
}

export enum HighRange {
  min = 40,
  max = 59,
}

export enum VeryHighRange {
  min = 60,
  max = 79,
}

export enum ExtremeRange {
  min = 80,
  max = 100,
}

export enum MoreRange {
  min = 100,
  max = 100000,
}
